import { Project } from "interfaces";

import * as flowConfig from "./config";

export interface TimeSeriesProject extends Project {
  flow: flowConfig.FLOW_TYPE;
  data_files: { [flowConfig.INPUT_DATA]: string };
  meta_data: {
    [flowConfig.TIMESTAMP_VAR]: string;
  };
}

export const projectIsTimeSeriesAnalysis = (
  project: Project
): project is TimeSeriesProject => project.flow === flowConfig.FLOW_NAME;
